import { ApiServiceException as __BaseException } from "../models/ApiServiceException";
import { BadGateway, BadRequest, Forbidden, InternalServerError, Locked, NotFound, PreconditionFailed, PreconditionRequired, Unauthorized, ValidationException, } from "../models/models_0";
import { loadRestJsonErrorCode, parseJsonBody as parseBody, parseJsonErrorBody as parseErrorBody, } from "@aws-sdk/core";
import { requestBuilder as rb } from "@smithy/core";
import { decorateServiceException as __decorateServiceException, expectBoolean as __expectBoolean, expectInt32 as __expectInt32, expectLong as __expectLong, expectNonNull as __expectNonNull, expectObject as __expectObject, expectString as __expectString, _json, collectBody, map, take, withBaseException, } from "@smithy/smithy-client";
export const se_AdyenWebhookCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json; charset=utf-8',
    };
    b.bp("/v1/internal/adyen/webhook");
    let body;
    if (input.body !== undefined) {
        body = input.body;
    }
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetFileByIdCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xah]: input[_a],
    });
    b.bp("/v1/files/{fileId}");
    b.p('fileId', () => input.fileId, '{fileId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreateOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/orders");
    let body;
    body = JSON.stringify(take(input, {
        'items': _ => _json(_),
        'partnerId': [],
        'propertyData': _ => _json(_),
        'userData': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreateOrderAsPartnerCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/partners/{partnerId}/orders");
    b.p('partnerId', () => input.partnerId, '{partnerId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'items': _ => _json(_),
        'propertyData': _ => _json(_),
        'userData': _ => _json(_),
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreatePaymentSessionForOrderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/orders:payment/{orderId}");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_DeletePowerOfAttornyCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/orders/{orderId}");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    let body;
    b.m("DELETE")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetOrderByAccessIdCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/orders:access/{accessId}");
    b.p('accessId', () => input.accessId, '{accessId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetOrderJWTByAccessIdCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        [_xah]: input[_a],
    });
    b.bp("/v1/orders:token/{accessId}");
    b.p('accessId', () => input.accessId, '{accessId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_SendPOAEMailCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/orders/{orderId}/poa:email");
    b.p('orderId', () => input.orderId, '{orderId}', false);
    let body;
    if (input.body !== undefined) {
        body = _json(input.body);
    }
    if (body === undefined) {
        body = {};
    }
    body = JSON.stringify(body);
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdateOrderDataCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = map({}, isSerializableHeaderValue, {
        'content-type': 'application/json',
        [_xah]: input[_a],
    });
    b.bp("/v1/orders");
    let body;
    body = JSON.stringify(take(input, {
        'items': _ => _json(_),
        'orderId': [],
        'propertyData': _ => _json(_),
        'userData': _ => _json(_),
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UploadPowerOfAttornyCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/orders:poa");
    let body;
    body = JSON.stringify(take(input, {
        'contentType': [],
        'fileExtension': [],
        'fileName': [],
        'orderId': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_CreatePartnerCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/admin/partners");
    let body;
    body = JSON.stringify(take(input, {
        'isActive': [],
        'name': [],
        'partnerLogoUrl': [],
        'partnerSubfolder': [],
        'themeTemplateToken': [],
    }));
    b.m("POST")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetPartnerByIdCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/admin/partners/{partnerId}");
    b.p('partnerId', () => input.partnerId, '{partnerId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetPartnerBySubfolderCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/partners/subfolder/{partnerSubfolder}");
    b.p('partnerSubfolder', () => input.partnerSubfolder, '{partnerSubfolder}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetPartnersCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/admin/partners");
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdatePartnerCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/admin/partners");
    let body;
    body = JSON.stringify(take(input, {
        'isActive': [],
        'name': [],
        'partnerId': [],
        'partnerLogoUrl': [],
        'partnerSubfolder': [],
        'themeTemplateToken': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetAllProductsForPartnerCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/admin/partners/{partnerId}/products");
    b.p('partnerId', () => input.partnerId, '{partnerId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_GetProductsForPartnerCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {};
    b.bp("/v1/partners/{partnerId}/products");
    b.p('partnerId', () => input.partnerId, '{partnerId}', false);
    let body;
    b.m("GET")
        .h(headers)
        .b(body);
    return b.build();
};
export const se_UpdateProductCommand = async (input, context) => {
    const b = rb(input, context);
    const headers = {
        'content-type': 'application/json',
    };
    b.bp("/v1/admin/partners/{partnerId}/products");
    b.p('partnerId', () => input.partnerId, '{partnerId}', false);
    let body;
    body = JSON.stringify(take(input, {
        'isActiveForPartner': [],
        'partnerSurcharge': [],
        'productType': [],
    }));
    b.m("PATCH")
        .h(headers)
        .b(body);
    return b.build();
};
export const de_AdyenWebhookCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_GetFileByIdCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'fileUrl': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreateOrderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessId': __expectString,
        'accessToken': __expectString,
        'files': _json,
        'items': _json,
        'orderId': __expectString,
        'orderReference': __expectString,
        'orderStatus': __expectString,
        'orderedAt': __expectLong,
        'partnerId': __expectString,
        'propertyData': _json,
        'session': _json,
        'userData': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreateOrderAsPartnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessId': __expectString,
        'accessToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreatePaymentSessionForOrderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessId': __expectString,
        'files': _json,
        'items': _json,
        'orderId': __expectString,
        'orderReference': __expectString,
        'orderStatus': __expectString,
        'orderedAt': __expectLong,
        'partnerId': __expectString,
        'propertyData': _json,
        'session': _json,
        'userData': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_DeletePowerOfAttornyCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_GetOrderByAccessIdCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessId': __expectString,
        'files': _json,
        'items': _json,
        'orderId': __expectString,
        'orderReference': __expectString,
        'orderStatus': __expectString,
        'orderedAt': __expectLong,
        'partnerId': __expectString,
        'propertyData': _json,
        'session': _json,
        'userData': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetOrderJWTByAccessIdCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_SendPOAEMailCommand = async (output, context) => {
    if (output.statusCode !== 204 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    await collectBody(output.body, context);
    return contents;
};
export const de_UpdateOrderDataCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'accessId': __expectString,
        'files': _json,
        'items': _json,
        'orderId': __expectString,
        'orderReference': __expectString,
        'orderStatus': __expectString,
        'orderedAt': __expectLong,
        'partnerId': __expectString,
        'propertyData': _json,
        'session': _json,
        'userData': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UploadPowerOfAttornyCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'uploadUrl': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_CreatePartnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'created': __expectInt32,
        'isActive': __expectBoolean,
        'name': __expectString,
        'partnerId': __expectString,
        'partnerLogoUrl': __expectString,
        'partnerSubfolder': __expectString,
        'themeTemplateToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetPartnerByIdCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'created': __expectInt32,
        'isActive': __expectBoolean,
        'name': __expectString,
        'partnerId': __expectString,
        'partnerLogoUrl': __expectString,
        'partnerSubfolder': __expectString,
        'products': _json,
        'themeTemplateToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetPartnerBySubfolderCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'name': __expectString,
        'partnerId': __expectString,
        'partnerLogoUrl': __expectString,
        'products': _json,
        'themeTemplateToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetPartnersCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectObject(await parseBody(output.body, context));
    contents.body = _json(data);
    return contents;
};
export const de_UpdatePartnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'created': __expectInt32,
        'isActive': __expectBoolean,
        'name': __expectString,
        'partnerId': __expectString,
        'partnerLogoUrl': __expectString,
        'partnerSubfolder': __expectString,
        'themeTemplateToken': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetAllProductsForPartnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'partnerId': __expectString,
        'products': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_GetProductsForPartnerCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'partnerId': __expectString,
        'products': _json,
    });
    Object.assign(contents, doc);
    return contents;
};
export const de_UpdateProductCommand = async (output, context) => {
    if (output.statusCode !== 200 && output.statusCode >= 300) {
        return de_CommandError(output, context);
    }
    const contents = map({
        $metadata: deserializeMetadata(output),
    });
    const data = __expectNonNull((__expectObject(await parseBody(output.body, context))), "body");
    const doc = take(data, {
        'deliveryTime': __expectString,
        'isActiveForPartner': __expectBoolean,
        'partnerId': __expectString,
        'partnerSurcharge': __expectInt32,
        'productType': __expectString,
    });
    Object.assign(contents, doc);
    return contents;
};
const de_CommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context)
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "BadGateway":
        case "de.europace.unterlagenshop.api#BadGateway":
            throw await de_BadGatewayRes(parsedOutput, context);
        case "BadRequest":
        case "de.europace.unterlagenshop.api#BadRequest":
            throw await de_BadRequestRes(parsedOutput, context);
        case "Forbidden":
        case "de.europace.unterlagenshop.api#Forbidden":
            throw await de_ForbiddenRes(parsedOutput, context);
        case "InternalServerError":
        case "de.europace.unterlagenshop.api#InternalServerError":
            throw await de_InternalServerErrorRes(parsedOutput, context);
        case "Locked":
        case "de.europace.unterlagenshop.api#Locked":
            throw await de_LockedRes(parsedOutput, context);
        case "NotFound":
        case "de.europace.unterlagenshop.api#NotFound":
            throw await de_NotFoundRes(parsedOutput, context);
        case "PreconditionFailed":
        case "de.europace.unterlagenshop.api#PreconditionFailed":
            throw await de_PreconditionFailedRes(parsedOutput, context);
        case "Unauthorized":
        case "de.europace.unterlagenshop.api#Unauthorized":
            throw await de_UnauthorizedRes(parsedOutput, context);
        case "ValidationException":
        case "smithy.framework#ValidationException":
            throw await de_ValidationExceptionRes(parsedOutput, context);
        case "PreconditionRequired":
        case "de.europace.unterlagenshop.api#PreconditionRequired":
            throw await de_PreconditionRequiredRes(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            return throwDefaultError({
                output,
                parsedBody,
                errorCode
            });
    }
};
const throwDefaultError = withBaseException(__BaseException);
const de_BadGatewayRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new BadGateway({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_BadRequestRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new BadRequest({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ForbiddenRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new Forbidden({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_InternalServerErrorRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new InternalServerError({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_LockedRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new Locked({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_NotFoundRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new NotFound({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_PreconditionFailedRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new PreconditionFailed({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_PreconditionRequiredRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new PreconditionRequired({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_UnauthorizedRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new Unauthorized({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const de_ValidationExceptionRes = async (parsedOutput, context) => {
    const contents = map({});
    const data = parsedOutput.body;
    const doc = take(data, {
        'fieldList': _json,
        'message': __expectString,
    });
    Object.assign(contents, doc);
    const exception = new ValidationException({
        $metadata: deserializeMetadata(parsedOutput),
        ...contents
    });
    return __decorateServiceException(exception, parsedOutput.body);
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then(body => context.utf8Encoder(body));
const isSerializableHeaderValue = (value) => value !== undefined &&
    value !== null &&
    value !== "" &&
    (!Object.getOwnPropertyNames(value).includes("length") ||
        value.length != 0) &&
    (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
const _a = "access";
const _xah = "x-access-hash";
